
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// NOT: Çözünürlük bağımsız ölçekleme (1080p tuval + zoom) App.jsx içinde
// applyDesignScale ile yapılır; buradaki eski DPI zoom düzeltmesi kaldırıldı.

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
)
